import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

const ScoreEntryTeamHeader = ({ 
  teamLogo, 
  teamName, 
  scoresEntered, 
  totalPlayers, 
  teamScore,
  completedTeams,
  setCompletedTeams,
  teamId 
}) => {

    const allTeamPicksIn = scoresEntered === totalPlayers;

    // Use a ref to track previous completion state
    const prevCompletionState = useRef(false);

    // Only update completedTeams when the completion state changes
    useEffect(() => {
        // Only run the effect if completion state has changed
        if (allTeamPicksIn !== prevCompletionState.current) {
            if (allTeamPicksIn) {
                // Check if the teamId is already in the completedTeams array
                const teamExists = completedTeams?.some(team => team.teamId === teamId);
                if (!teamExists) {
                    // If not, add the teamId to the completedTeams array
                    setCompletedTeams(prev => [...prev, { teamId }]);
                }
            } else {
                // If the team is not complete, remove it from the completedTeams array
                setCompletedTeams(prev => prev.filter(team => team.teamId !== teamId));
            }
            
            // Update the ref with current state
            prevCompletionState.current = allTeamPicksIn;
        }
    }, [allTeamPicksIn, teamId, completedTeams, setCompletedTeams]);

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center',
        width: '90%',
        maxWidth: '400px',
        margin: '0 auto',
      }}
    >
      {/* Logo and Scores Entered Row */}
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          width: '80%',
          mb: 2
        }}
      >
        {/* Logo */}
        <Box 
          component="img"
          src={teamLogo}
          alt={`${teamName} logo`}
          sx={{ 
            width: 80,
            height: 80,
            borderRadius: '4px'
          }}
        />
        
        {/* Scores Entered Section */}
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Typography 
                variant="h6"
                sx={{ 
                fontWeight: 700, 
                fontSize: '16px',
                textTransform: 'uppercase',
                textAlign: 'right',
                mb: 0.5
                }}
            >
                SCORES ENTERED
            </Typography>
          
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography 
                sx={{ 
                    color: allTeamPicksIn ? '#00AA72' : '#CC293C',
                    fontWeight: 700,
                    fontSize: '16px',
                    mr: 1
                }}
                >
                ({scoresEntered} / {totalPlayers})
                </Typography>
                {allTeamPicksIn ? 
                <CheckIcon sx={{ color: '#00AA72', fontSize: 24 }} /> : 
                <CloseIcon sx={{ color: '#CC293C', fontSize: 24 }} />
                }
            </Box>
        </Box>
      </Box>
      
      {/* Team Score */}
      <Typography 
        variant="h5"
        sx={{ 
          fontWeight: 700, 
          fontSize: '24px',
          textAlign: 'center',
          width: '100%',
          mt: 1
        }}
      >
        Team Score: ({teamScore > 0 ? '+' : ''}{teamScore === 0 ? 'E' : teamScore})
      </Typography>
    </Box>
  );
};

// Default props
ScoreEntryTeamHeader.defaultProps = {
  teamLogo: '/path/to/default-logo.png',
  teamName: 'Team Name',
  scoresEntered: 0,
  totalPlayers: 0,
  teamScore: 0
};

export default ScoreEntryTeamHeader;